export const styles = {
  iconButton: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
};
